import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router'
import Button from 'material-ui/Button'
import withTheme from 'material-ui/styles/withTheme'
import {compose} from 'redux'
import {firebaseConnect, isLoaded, isEmpty} from 'react-redux-firebase'
import {push} from 'react-router-redux'
import BottomNavigation, { BottomNavigationAction } from 'material-ui/BottomNavigation';

import ExtensionIcon from 'material-ui-icons/Extension';
import PersonIcon from 'material-ui-icons/Person';
import InsertEmoticonIcon from 'material-ui-icons/InsertEmoticon';
import WorkIcon from 'material-ui-icons/Work';
import CognitiveTestContainer from './CognitiveTestContainer'
import OtherTestContainer from './OtherTestContainer';
import {cognitive, personality, softskills, wp} from '../testPool'


class TestContainer extends Component {
    render() {
      return (
        <div>
            {!isEmpty(this.props.profile)&&
              (this.props.profile.currentTest === 'cognitive')&&
                <CognitiveTestContainer profile={this.props.profile}/>
            }
            {!isEmpty(this.props.profile)&&
              (this.props.profile.currentTest !== 'cognitive' && this.props.profile.currentTest !== 'finished')&&
                <OtherTestContainer profile={this.props.profile}/>
            }
            {!isEmpty(this.props.profile)&&
              !isEmpty(this.props.profile.currentTest)&&
                <BottomNavigation value={this.props.profile.currentTest} style={{position: 'fixed', bottom: '0', width: '100%'}}>
                  <BottomNavigationAction disabled label="การเรียนรู้" value="cognitive" icon={<ExtensionIcon />} />
                  <BottomNavigationAction disabled label="บุคลิกภาพ" value="personality" icon={<PersonIcon />} />
                  <BottomNavigationAction disabled label="การปฏิบัติงาน" value="softskills" icon={<InsertEmoticonIcon />} />
                  <BottomNavigationAction disabled label="ความสนใจ" value="wp" icon={<WorkIcon />} />
                </BottomNavigation>
            }
            
        </div>
      )
    }
  }
  
  export default compose(
    firebaseConnect(),
    withTheme(),
  connect(({firebase: {profile}})=>({profile})))(TestContainer)


// WEBPACK FOOTER //
// ./src/test/TestContainer.js